import { plainToClass } from "class-transformer";

import { FormInstanceElement } from '../form-builder/form-instance-element.model';
import { PickerItem } from "../picker-item.model";

// Define a contacts data type.
export interface IContactInfo {
    userId: string;
    fullName: string;
    email: string;
    phone: string;
    agencyShortName: string;
    isPrimaryContact: boolean;
}

export class ContactInfo implements IContactInfo {
    public static readonly FIELD_INTERNAL_NAME_CONTACT_NAME: string = "contactnamedonotedit";
    public static readonly FIELD_INTERNAL_NAME_CONTACT_EMAIL: string = "contactemaildonotedit";
    public static readonly FIELD_INTERNAL_NAME_CONTACT_PHONE: string = "contactphonedonotedit";
    public static readonly FIELD_INTERNAL_NAME_CONTACT_AGENCY: string = "contactagencydonotedit";
    public static readonly FIELD_INTERNAL_NAME_IS_PRIMARY_CONTACT: string = "contactisprimarydonotedit";

    // Properties.
    public userId: string;
    public fullName: string;
    public email: string;
    public phone: string;
    public agencyShortName: string;
    public isPrimaryContact: boolean;

    public constructor(pickerItem: PickerItem, isPrimaryContact: boolean = false) {
        this.fullName = pickerItem.displayName;
        this.email = pickerItem.secondaryDisplayName;
        this.phone = pickerItem.phone;
        this.agencyShortName = pickerItem.agencyShortName;
        this.isPrimaryContact = isPrimaryContact;
    }
}

// Define a contacts data structure.
export class ContactsFormFieldData {
    // Property.
    public contacts: IContactInfo[] = [];

    // Constructor.
    public constructor() { }

    // Method(s).
    public containsUser(userMaxId: string): boolean {
        let containsUser: boolean = false;

        if (this.contacts && (this.contacts.length > 0)) {
            let contact: IContactInfo = this.contacts.find(c => c.userId == userMaxId);
            containsUser = (contact != null);
        }

        return containsUser;
    }

    // Static method.
    public static deserializeData(formInstanceElement: FormInstanceElement): ContactsFormFieldData {
        let data: ContactsFormFieldData = null;

        if (formInstanceElement.textValue && (formInstanceElement.textValue.trim() != '')) {
            let hshData: any = JSON.parse(formInstanceElement.textValue);
            data = plainToClass(ContactsFormFieldData, hshData);
        } else
            data = new ContactsFormFieldData();

        return data;
    }
}
